import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';

import { LetDirective } from '@ngrx/component';
import { TranslatePipe } from '@ngx-translate/core';
import type { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs';

import { PersuadeCardComponent } from '@valk-nx/compositions/ui-persuade-card/src/lib/persuade-card.component';
import { PRICING_TOOLTIP_OCCUPANCY } from '@valk-nx/core/lib/core';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { ContentService } from '@valk-nx/storyblok-services/src/lib/services/content.service';
import { StoryblokService } from '@valk-nx/storyblok-services/src/lib/services/storyblok.service';
import type { PackageData } from '@valk-nx/storyblok-types/src/lib/types/content.interface';
import type { Button } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	selector: 'sb-package-card',
	templateUrl: './package-card.html',
	imports: [
		CommonModule,
		LetDirective,
		PersuadeCardComponent,
		TranslatePipe,
		StoryblokDirective,
	],
	host: { class: 'size-full' },
})
export class PackageCardComponent extends StoryblokRootDirective {
	private readonly contentService = inject(ContentService);
	private readonly sbService = inject(StoryblokService);

	package = input.required<string>();
	useVertical = input.required<boolean>();
	button = input.required<Button[]>();
	stopGrow = input<boolean>(false);

	package$: Observable<PackageData | undefined>;

	pricingTooltipOccupancy = PRICING_TOOLTIP_OCCUPANCY;

	constructor() {
		super();

		this.package$ = this.sbService.translatedSlugs$.pipe(
			map((translatedSlugs) => {
				return (
					translatedSlugs.find((x) => x.selected) ??
					translatedSlugs[0]
				);
			}),
			switchMap((slug) => {
				return this.contentService.getPackages(slug.lang.toLowerCase());
			}),
			map((response) => {
				return response?.data.find((x) => x.guid === this.package());
			}),
		);
	}
}
